/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import formatDate from '../../../helpers/formatDate'
import { Image, Icon, TableRow, TableCell } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { UltyMoney } from '@ulty/ulty-ui'
import useUser from '../../Shared/UserProvider/useUser'

const ProductSyncStatePlatformItem = ({pf}) => {
    const [t] = useTranslation()
    const {user} = useUser()

    return (
      <TableRow>
          <TableCell textAlign="left">
              {pf.brand.name}
          </TableCell>
          <TableCell>
              <div css={css`
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  img {
                      max-width: 40px !important;
                      height: auto !important;
                  }

                  & > .platform-label {
                      padding-left: 20px;
                      font-weight: bold;
                  }
              `}>
                  <Image wrapped src={pf.platform.logo}/>
                  <div className="platform-label">{pf.platform.name}</div>
              </div>
          </TableCell>
          <TableCell>
              {pf.price ?
                <UltyMoney
                  readonly
                  currencyCode={user.getCompanyCurrency()}
                  locale={user.getCompanyLocale()}
                  amount={pf.price}
                />
                : '-'}
          </TableCell>
          <TableCell>{typeof pf.stock === 'undefined' ? '-' : (parseInt(pf.stock) === 0 ? '0' : '> 0')}</TableCell>
          <TableCell>
              {(
                <>
                    {pf.syncState === 'OK' && (
                      <>
                          <Icon name="check circle outline" color="green"/> {t('item_sync.synchronized')}
                      </>
                    )}
                    {pf.syncState === 'FAILED' && (
                      <>
                          <Icon name="warning circle" color="red"/> {t('item_sync.error')}
                      </>
                    )}
                    {pf.syncState === 'FAILED-STOCKS' && (
                      <>
                          <Icon name="warning circle" color="red"/> {t('item_sync.stock_error')}
                      </>
                    )}
                    {pf.syncState === 'WAITING' && (
                      <>
                          <Icon name="refresh" color="teal"/> {t('item_sync.in_progress')}
                      </>
                    )}
                    {pf.syncState === 'IGNORED' && (
                      <>
                          <Icon name="warning circle" color="orange"/> {
                          (pf.syncError?.reason === 'TOO_MANY_ITEMS' ?
                              t('item_sync.ignored_TOO_MANY_ITEMS', {
                                  limit: pf.syncError.maxLimit,
                                  nbItems: pf.syncError.nbItems,
                              })
                              : t('item_sync.ignored')
                          )
                      }
                      </>
                    )}
                </>
              )}
          </TableCell>
          <TableCell>{formatDate(pf.syncDate)}</TableCell>
      </TableRow>
    )
}

export default ProductSyncStatePlatformItem
